import styled from 'styled-components';

const Container = styled.div`
  svg {
    height: 10px;
    width: 10px;
    fill: ${(p) => p.theme.color.gray};
    transition: transform ${(p) => p.theme.duration.m} ease-in-out;
    transform: ${(p) => (p.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`;

export const Styled = {
  Container,
};
